import api from './api';
import { Product, CreateProductDto } from '../types';

export const productsService = {
    getAll: async (search?: string) => {
        const response = await api.get<Product[]>('/products', {
            params: { search }
        });
        return response.data;
    },

    getById: async (id: string) => {
        const response = await api.get<Product>(`/products/${id}`);
        return response.data;
    },

    create: async (data: CreateProductDto) => {
        const response = await api.post<Product>('/products', data);
        return response.data;
    },

    update: async (id: string, data: Partial<CreateProductDto>) => {
        const response = await api.patch<Product>(`/products/${id}`, data);
        return response.data;
    },

    delete: async (id: string) => {
        await api.delete(`/products/${id}`);
    },
};
